import { render, staticRenderFns } from "./LimitAccessAlert.vue?vue&type=template&id=11a11c4c&scoped=true"
import script from "./LimitAccessAlert.vue?vue&type=script&lang=js"
export * from "./LimitAccessAlert.vue?vue&type=script&lang=js"
import style0 from "./LimitAccessAlert.vue?vue&type=style&index=0&id=11a11c4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a11c4c",
  null
  
)

export default component.exports